import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/donation-setup/campaigns";

export const Route = createFileRoute("/admin/_donation-setup/campaigns")({
  component: Page,
});
